// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Translate, PropTypes, classNames } from '@plesk/ui-library';

const Status = ({ messages }) => (
    <div>
        {messages.map((msg, index) => (
            <div
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className={classNames('msg-box', `msg-${msg.status}`, msg.class)}
                data-source={msg.source}
            >
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <div className="msg-content">
                                        <span className="title">
                                            <Translate content={`components.status.${msg.status}`} />{': '}
                                        </span>
                                        <span
                                            // eslint-disable-next-line react/no-danger
                                            dangerouslySetInnerHTML={{ __html: msg.content }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
);

Status.propTypes = {
    messages: PropTypes.array.isRequired,
};

export default Status;



// WEBPACK FOOTER //
// ./plesk/Status.js